import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { ApplicationListingContainer as Listing } from '@/microfrontends/listing/shared';

import { selectComparisonNotificationState } from '@/packages/redux-state/store/slices/comparisonNotification/selectors/selectComparisonNotificationState';

import { ChatPopupContainer } from '../../components/ChatPopup';
import { ComparisonNotificationContainerLoadable } from '../../components/ComparisonNotification';
import { useApplicationContext } from '../../context/ApplicationContext';

export const ListingLayoutContainer: FC = () => {
  const context = useApplicationContext();

  const { comparisonNotification } = useSelector(selectComparisonNotificationState);

  return (
    <>
      <Listing context={context} />
      <ChatPopupContainer />
      {comparisonNotification && <ComparisonNotificationContainerLoadable notification={comparisonNotification} />}
    </>
  );
};
